import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuButton, MenuList, Portal } from '@chakra-ui/react';

import CustomIcon from '../icon/CustomIcon';
import NavigationItem from './NavigationItem';
import type { NavigationMenuItem } from './types';

interface Props<Routes extends string> {
  items: NavigationMenuItem<Routes>[];
}

const NavigationHelpMenu = <Routes extends string>({ items }: Props<Routes>) => {
  const { t } = useTranslation('shared');

  return (
    <Menu isLazy placement='right-end'>
      <MenuButton
        data-testid='help-menu-button'
        as={IconButton}
        variant='menuIcon'
        display={{ base: 'none', md: 'inline-flex' }}
        aria-label={t('navigation.help')}
        backgroundColor='transparent'
        icon={<CustomIcon name='help-circle' color='current' secondaryColor='current' unfilled />}
        title={t('navigation.help')}
      />
      <Portal>
        {/*
         * The MenuList uses the css 'inset' property which is safari 14+
         * This causes the body of overflow since the list is not properly hidden
         * https://github.com/chakra-ui/chakra-ui/blob/main/packages/menu/src/menu.tsx#L165
         */}
        <MenuList
          rootProps={{
            top: 0,
            left: 0,
          }}>
          {items.map((item) => (
            <NavigationItem
              data-testid={`help-menu-${item.href}`}
              key={item.label}
              type='menuItem'
              to={item.href}
              label={item.label}
              icon={<CustomIcon name={item.customIconName} />}
              onClick={item.onClick}
            />
          ))}
        </MenuList>
      </Portal>
    </Menu>
  );
};

export default NavigationHelpMenu;
